import * as React from 'react';
import { FormEvent, useState } from 'react';
import t from '../../theme';
import { addIconStyle, cancelButtonStyle, editIconStyle, saveButtonStyle } from '../../style';
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    ListItemButton,
    TextField,
    Typography
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FrequentlyAskedQuestion } from '../../lib/models/SupportModels';
import { listItemButtonStyles } from '../ListItemWideButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { EMPTY_GUID } from '../../lib/constants/misc';
import { StyledDialogActions } from '../../styledComponents';

interface FAQModalProps {
    dto: FrequentlyAskedQuestion;
    onUpsertFAQ: (event: FormEvent, faq: FrequentlyAskedQuestion) => void;
}

const QnAModal = (props: FAQModalProps) => {
    const { id, question, answer, isActive } = props.dto;
    const { onUpsertFAQ } = props;

    const title = 'Frequently Asked Question';
    const [isDialogOpened, setDialogOpened] = useState(false);
    const [questionValue, setQuestionValue] = useState(question);
    const [answerValue, setAnswerValue] = useState(answer);

    const handleOpenDialog = () => setDialogOpened(true);

    const handleCloseDialog = () => {
        setDialogOpened(false);
    };

    const handleSave = async (event: FormEvent) => {
        event.preventDefault();
        const faqUpdate: FrequentlyAskedQuestion = {
            question: questionValue,
            answer: answerValue,
            isActive: isActive,
            id: id
        };

        onUpsertFAQ(event, faqUpdate);

        if (faqUpdate.id === EMPTY_GUID) {
            setQuestionValue('');
            setAnswerValue('');
        }

        //Close Dialog window
        setDialogOpened(false);
    };

    return (
        <div>
            {id !== EMPTY_GUID && (
                <IconButton aria-label="edit" onClick={handleOpenDialog}>
                    <EditOutlinedIcon sx={editIconStyle} />
                </IconButton>
            )}

            {id === EMPTY_GUID && (
                <ListItemButton sx={listItemButtonStyles} onClick={() => setDialogOpened(true)}>
                    <Box
                        sx={{
                            display: 'flex',
                            margin: 'auto',
                            minHeight: '2.5rem',
                            alignItems: 'center'
                        }}>
                        <AddCircleOutlineIcon sx={addIconStyle} />
                        <Typography variant="h4" sx={{ color: t.palette.primary.light }}>
                            Add Frequently Asked Question Item
                        </Typography>
                    </Box>
                </ListItemButton>
            )}

            <Dialog open={isDialogOpened} onClose={handleCloseDialog}>
                <DialogTitle variant="h3">{title}</DialogTitle>
                <form onSubmit={handleSave}>
                    <DialogContent>
                        <TextField
                            required
                            multiline
                            margin="dense"
                            id="question"
                            label="Question"
                            type="text"
                            fullWidth
                            variant="outlined"
                            inputProps={{ inputMode: 'text' }}
                            value={questionValue}
                            onChange={(v) => setQuestionValue(v.target.value)}
                        />
                        <TextField
                            required
                            multiline
                            margin="dense"
                            id="answer"
                            label="Answer"
                            type="text"
                            fullWidth
                            variant="outlined"
                            inputProps={{ inputMode: 'text' }}
                            value={answerValue}
                            onChange={(v) => setAnswerValue(v.target.value)}
                        />
                    </DialogContent>
                    <StyledDialogActions>
                        <Button sx={cancelButtonStyle} onClick={handleCloseDialog}>
                            Cancel
                        </Button>
                        <Button sx={saveButtonStyle} type="submit">
                            Save
                        </Button>
                    </StyledDialogActions>
                </form>
            </Dialog>
        </div>
    );
};

export default QnAModal;
